import { render, staticRenderFns } from "./IframeRelay.vue?vue&type=template&id=556b2a16&scoped=true&"
import script from "./IframeRelay.vue?vue&type=script&lang=js&"
export * from "./IframeRelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b2a16",
  null
  
)

export default component.exports